export interface IResolvedLocale {
  isPortuguese: boolean;
  intlLocale: 'pt-BR' | 'en-US';
  currencyCode: 'BRL' | 'USD';
  dateOnlyFormat: 'dd/MM/yyyy' | 'MM/dd/yyyy';
  dateTimeFormat: 'dd/MM/yyyy HH:mm' | 'MM/dd/yyyy HH:mm';
}

export function isPortugueseLanguage(language: string): boolean {
  return language.startsWith('pt');
}

export function resolveLocale(language: string): IResolvedLocale {
  const isPortuguese = isPortugueseLanguage(language);

  return {
    isPortuguese,
    intlLocale: isPortuguese ? 'pt-BR' : 'en-US',
    currencyCode: isPortuguese ? 'BRL' : 'USD',
    dateOnlyFormat: isPortuguese ? 'dd/MM/yyyy' : 'MM/dd/yyyy',
    dateTimeFormat: isPortuguese ? 'dd/MM/yyyy HH:mm' : 'MM/dd/yyyy HH:mm',
  };
}
